import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tokens: {
      access_token: null,
      refresh_token: null
    },
    firstName: "",
    lastName: "",
    userName: "",
    dealerCode: "",
    apps: [
      {
        application_id: 0,
        application_name: "unknow",
        application_url: "#"
      }
    ]
  },
  getters: {
    isAuth: state => state.tokens.access_token != null,
    fullName: state => state.firstName + " " + state.lastName,
    dealer: state => (state.dealerCode == "75001" ? "admin" : state.dealerCode),
    welcomeMsg: (state, getters) =>
      getters.isAuth ? "Witaj " + getters.fullName : "Proszę się zalogować"
  },
  mutations: {
    setAuth(state, payload) {
      state.tokens.access_token = payload.access_token.token;
      state.tokens.refresh_token = payload.refresh_token.token;
    },
    setInfoAboutUser(state, payload) {
      state.firstName = payload.imie;
      state.lastName = payload.nazwisko;
      state.userName = payload.nazwa;
      state.dealerCode = payload.dealer;
    },
    clearAuth(state) {
      state.tokens.access_token = null;
      state.tokens.refresh_token = null;
      state.firstName = "";
      state.lastName = "";
      state.userName = "";
      state.dealerCode = "";
      state.apps = [];
    }
  },
  actions: {
    saveTokens({ commit }, payload) {
      sessionStorage.setItem("refreshToken", payload.refresh_token.token);
      sessionStorage.setItem(
        "refreshExpires",
        new Date(payload.refresh_token.expires_timestamp * 1000).toString()
      );
      sessionStorage.setItem("accessToken", payload.access_token.token);
      sessionStorage.setItem(
        "accessExpires",
        new Date(payload.access_token.expires_timestamp * 1000).toString()
      );
      commit("setAuth", payload);
    },
    async doRenew({ state, dispatch }) {
      if (
        state.tokens.access_token != null &&
        state.tokens.refresh_token != null
      ) {
        let { data } = await axios.post(
          "https://testdealer.fiat.pl/api/auth/refresh_token.php",
          {
            ...state.tokens
          }
        );
        if (data.errors) alert(JSON.stringify(data.errors));
        else {
          this.dispatch("saveTokens", {
            ...data.informations_about_renewed_tokens
          });
          dispatch(
            "scheduleRenewalAfterTimeout",
            data.informations_about_renewed_tokens.access_token
              .expires_timestamp * 1000
          );
        }
      }
    },
    scheduleRenewalAfterTimeout(
      { dispatch },
      accessExpirationDateTimeInPayload
    ) {
      setTimeout(() => {
        dispatch("doRenew");
      }, accessExpirationDateTimeInPayload - new Date().getTime());
    },
    async getApplicationPermissions({ state }) {
      if (state.tokens.access_token != null) {
        let { data } = await axios.post(
          "https://testdealer.fiat.pl/api/auth/application_permissions.php",
          {
            access_token: state.tokens.access_token
          }
        );
        if (data.errors) alert(JSON.stringify(data.errors));
        else state.apps = data.applications_info;
        state.apps = state.apps.map(function(value) {
          if (value.application_url == "../lcv")
            value.application_url = "/platforma_dla_lcv/Entry";
          return value;
        });
      }
    },
    async signin({ commit, dispatch }, payload) {
      try {
        let { data } = await axios.post(
          "https://testdealer.fiat.pl/api/auth/login.php",
          payload
        );
        if (data.errors) alert(data.errors[0]);
        else {
          //commit("setAuth", data.tokens);
          commit("setInfoAboutUser", data);
          this.dispatch("saveTokens", {
            ...data.tokens
          });
          sessionStorage.setItem("dealerCode", data.dealer);
          sessionStorage.setItem("firstName", data.imie);
          sessionStorage.setItem("lastName", data.nazwisko);
          sessionStorage.setItem("userName", data.nazwa);
          sessionStorage.setItem("userId", data.personel_id);
          dispatch("getApplicationPermissions");
          dispatch(
            "scheduleRenewalAfterTimeout",
            data.tokens.access_token.expires_timestamp * 1000
          );
        }
      } catch (e) {
        //console.log("Async Error", e);
        alert("Async Error:" + JSON.stringify(e));
      }
    },
    signout({ commit }) {
      commit("clearAuth");
      sessionStorage.removeItem("accessExpires");
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("dealerCode");
      sessionStorage.removeItem("firstName");
      sessionStorage.removeItem("lastName");
      sessionStorage.removeItem("userName");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("refreshExpires");
      sessionStorage.removeItem("refreshToken");
    },
    autologin({ commit, dispatch }) {
      const accessExpires = sessionStorage.getItem("accessExpires");
      if (!accessExpires) {
        return;
      }
      const access_token = sessionStorage.getItem("accessToken");
      if (!access_token) {
        return;
      }
      const dealer = sessionStorage.getItem("dealerCode");
      if (!dealer) {
        return;
      }
      const imie = sessionStorage.getItem("firstName");
      if (!imie) {
        return;
      }
      const nazwisko = sessionStorage.getItem("lastName");
      if (!nazwisko) {
        return;
      }
      const nazwa = sessionStorage.getItem("userName");
      if (!nazwa) {
        return;
      }
      const userId = sessionStorage.getItem("userId");
      if (!userId) {
        return;
      }
      const refreshExpires = sessionStorage.getItem("refreshExpires");
      if (!refreshExpires) {
        return;
      }
      const refresh_token = sessionStorage.getItem("refreshToken");
      if (!refresh_token) {
        return;
      }
      commit("setAuth", {
        access_token: {
          token: access_token
        },
        refresh_token: {
          token: refresh_token
        }
      });
      commit("setInfoAboutUser", {
        imie,
        nazwisko,
        nazwa,
        dealer
      });
      const now = new Date();
      const accessExpiresDateTime = new Date(accessExpires);
      if (now >= new Date(refreshExpires)) {
        dispatch("signout");
        return;
      }
      if (now >= accessExpiresDateTime) dispatch("doRenew");
      else
        dispatch(
          "scheduleRenewalAfterTimeout",
          accessExpiresDateTime.getTime()
        );
      dispatch("getApplicationPermissions");
    }
  },
  modules: {}
});
